import { SettlementExchangeRateItem } from './index';
import { ValidationError } from 'components/ui/excel-table/types';
import { TFunction } from 'i18next';
import { isNil } from 'lodash';

export const validateSettlementExchangeRate = (
  row: SettlementExchangeRateItem,
  rowIndex: number,
  _: SettlementExchangeRateItem[],
  t: TFunction
): ValidationError<SettlementExchangeRateItem>[] => {
  const errors: ValidationError<SettlementExchangeRateItem>[] = [];

  // Original Currency validation - Required
  if (!row.originalCurrency || row.originalCurrency.trim() === '') {
    errors.push({
      field: 'originalCurrency',
      message: t('validation.required', {
        field: t('contractAllocation.originalCurrency'),
      }),
      rowIndex,
    });
  }

  // Settlement Currency validation - Required
  if (!row.settlementCurrency || row.settlementCurrency.trim() === '') {
    errors.push({
      field: 'settlementCurrency',
      message: t('validation.required', {
        field: t('contractAllocation.settlementCurrency'),
      }),
      rowIndex,
    });
  }

  // Settlement Exchange Rate validation - Numeric and positive
  if (!isNil(row.settlementExchangeRate)) {
    if (isNaN(Number(row.settlementExchangeRate))) {
      errors.push({
        field: 'settlementExchangeRate',
        message: t('validation.numeric', {
          field: t('contractAllocation.settlementExchangeRate'),
        }),
        rowIndex,
      });
    } else if (Number(row.settlementExchangeRate) <= 0) {
      errors.push({
        field: 'settlementExchangeRate',
        message: t('validation.numericPositive', {
          field: t('contractAllocation.settlementExchangeRate'),
        }),
        rowIndex,
      });
    }
  }

  return errors;
};
